export const getPercentage = (count: number, total: number) => {
  const percent = (count / total) * 100;

  return Number.isInteger(percent) ? percent : Number(percent.toFixed(1));
};
